export default "__VITE_ASSET__hLh_I8Xf__"